<template>
    <div>
        <div class="pt-3">
            <Tabs :tabs tab-font-size="16" px="65" tab-margin-right="22" borderBottomWidth="2" :initial-tab="initialTab">
                <template v-slot:tab1>
                    <VacanciesList @create="onCreateVacancy" @edit="onEditVacancy" @view="onViewVacancy"  />
                </template>
                <template v-slot:tab2>
                    <RequestsList @create="onCreateRequest" />
                </template>
                <template v-slot:tab3>
                    <VacancyArchiveList @view="onViewVacancy" />
                </template>
            </Tabs>
        </div>
        <SidePanel ref="vacancyCard">
            <AddVacancy @close="vacancyCard.toggle()" />
        </SidePanel>

        <SidePanel ref="vacancyEdit">
            <EditVacancy @close="vacancyEdit.toggle()" :vacancy="currentVacancy" />
        </SidePanel>

        <SidePanel ref="vacancyView">
            <ViewVacancy @close="vacancyView.toggle()" :vacancy="currentVacancy" />
        </SidePanel>

        <SidePanel ref="requestCard">
            <AddRequest @close="requestCard.toggle()" />
        </SidePanel>
    </div>
</template>

<script setup lang="ts">
import { onMounted, ref, computed } from 'vue'
import Tabs from '@/components/Tabs.vue'
import { Tab } from '@/types'
import VacanciesList from '@/components/exchange/VacanciesList.vue'
import SidePanel from '@/components/schedule/SidePanel.vue'
import AddVacancy from '@/components/exchange/AddVacancy.vue'
import AddRequest from '@/components/exchange/AddRequest.vue'
import RequestsList from '@/components/exchange/RequestsList.vue'
import EditVacancy from '@/components/exchange/EditVacancy.vue'
import VacancyArchiveList from '@/components/exchange/VacancyArchiveList.vue'
import { useDepartmentStore } from '@/stores/departmentStore'
import { useExchangeStore } from '@/stores/exchangeStore'
import { useAuthStore } from '@/stores/authStore'
import { useToast } from 'vue-toast-notification'
import ViewVacancy from '@/components/exchange/ViewVacancy.vue'

const authStore = useAuthStore()
const departmentStore = useDepartmentStore()
const exchangeStore = useExchangeStore()

const toast = useToast({ position: 'top' })

const tabs: Tab[] = [
    { name: 'tab1', label: 'Мои вакансии', disabled: !authStore.permissions?.can_view_vacancies },
    { name: 'tab2', label: 'Запросы',  disabled: !authStore.permissions?.can_view_vacancy_requests },
    { name: 'tab3', label: 'Архив' }
]

const initialTab = computed(() => {
    if(authStore.permissions?.can_view_vacancies) return 'tab1'
    else if (authStore.permissions?.can_view_vacancy_requests) return 'tab2'
    else return 'tab3'
})
const vacancyCard = ref()
const vacancyEdit = ref()
const vacancyView = ref()
const requestCard = ref()
const currentVacancy = ref()

const onEditVacancy = (vacancy:any) => {
    currentVacancy.value = vacancy
    vacancyEdit.value.toggle()
}

const onViewVacancy = (vacancy:any) => {
    currentVacancy.value = vacancy
    vacancyView.value.toggle()
}

const onCreateVacancy = () => {
     if(authStore.permissions?.can_create_vacancy_exchange) {
        vacancyCard.value.toggle()
    } else {
        toast.error('У вас нет прав на данное действие')
    }
}

const onCreateRequest = () => {
     if(authStore.permissions?.can_create_vacancy_request) {
        requestCard.value.toggle()
    } else {
        toast.error('У вас нет прав на данное действие')
    }
}

onMounted(async () => {
    await departmentStore.fetchMyDepartments()
    await exchangeStore.fetchSkills()
})
</script>
